import { Injectable, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { AppConfigService } from '../common/services/app-config.service';
import { RxMethods } from '../common/services/rxjs.service';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';

export const broadCastChannel = new BroadcastChannel('ilms_session');

declare const document;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  serverUrl = this.appConfigService.appBaseUrl;
  errorData: {};
  timer: number;
  private timerHandle: any = null;
  timeInterval: any;
  bufferTime: number;
  isRejected = false;
  // public sessionWarningTimer = this.rxMethods.createSubjectService();
  // private destroyed = this.rxMethods.createSubjectService();
  dashboardItems: any[] = [];

  constructor(private appConfigService: AppConfigService,
    private rxMethods: RxMethods,
    private router: Router,
    private confirmationService: ConfirmationService) {

      broadCastChannel.onmessage = (event:any) => {
        if(event && event.data && event.data.action == "logout") {
          this.logout();
        }
      }
  }

  redirectUrl: string;

  setUserDetails(userDetails) {
    if (userDetails && userDetails.strToken) {
      localStorage.setItem('currentUser', JSON.stringify(userDetails));
    }
  }

  isLoggedIn() {
    if (localStorage.getItem('currentUser')) {
      return true;
    }
    return false;
  }

  getAuthorizationToken() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser.strToken;
  }

  getLoggedUserDetails() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser;
  }

  getLoggedUserName() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    return currentUser.USER_NAME;
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.router.navigate(['/login']);
    localStorage.clear();
    broadCastChannel.postMessage({"action":"logout"});
    setTimeout(() => {
      document.location.reload();
    }, 50);
  }


  displaySessionWarning() {
    // your display code here
    this.logout();
    this.router.navigate(['/login']);
  }

  initIdle() {
    this.startChecking();
    this.timerHandle = setTimeout(this.showConfirmLogout.bind(this), (this.appConfigService.idleTime));
  }

  startChecking() {
    // Bind the methods to the proper context
    document.onclick = this.resetTimer.bind(this);
    document.onkeypress = this.resetTimer.bind(this);
    this.bufferTime = Math.floor(this.appConfigService.idleBufferTime / 1000);
    this.timer = this.bufferTime;
  }

  stopChecking() {
    if (this.timerHandle) {
      clearTimeout(this.timeInterval);
      clearTimeout(this.timerHandle);
      this.timer = 0;
      this.timerHandle = null;
      this.timeInterval = null;
    }
  }

  checkTimer() {
    if (this.timer === 0) {
      this.stopChecking();
      this.logout();
      return;
    }
    this.timer = (this.timer - 1);
    const elem = document.getElementsByClassName('ui-confirmdialog-message');
    if (elem && elem[0]) {
      elem[0].innerText = 'you will be logged out in ' + this.timer + ' seconds.';
    }
    this.startTimer();
  }

  startTimer() {
    this.timeInterval = setTimeout(this.checkTimer.bind(this), 1000);
  }

  private showConfirmLogout() {
    this.startTimer();
    this.confirmationService.confirm({
      message: 'You will be logged out in ' + this.timer + ' seconds.',
      header: 'Session Warning',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Exit',
      rejectLabel: 'Stay',
      rejectVisible: true,
      accept: () => {
        this.logout();
      },
      reject: () => {
        this.isRejected = true;
        this.stopChecking();
        this.resetTimer();
      }
    });
  }

  resetTimer() {
    if (this.timerHandle) {
      clearTimeout(this.timerHandle);
      clearTimeout(this.timeInterval);
      this.timeInterval = null;
      this.timerHandle = null;
      this.timer = this.isRejected ? this.bufferTime : this.timer;
      this.isRejected = false;
    }
    this.timerHandle = setTimeout(this.showConfirmLogout.bind(this), (this.appConfigService.idleTime));
  }
}
